import React, { useCallback } from "react";
import { connect } from "react-redux";
import { Table } from "antd";
import { bindActionCreators } from "redux";
import { Creators as ReportActions } from "store/report/report-duck";
import { IItems } from "store/report/report-model";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

interface IPropsScreenReportGrid {
  items?: Array<IItems>;
  totalItems?: number;
  itemsByPage?: number;
  pageIndex?: number;
  columnsTable: any;
  isLoadingRegisters: boolean;
}
interface IDispatchProps {
  reportFetchRegisterAsync: (...args) => void;
  reportChangeFieldValue: (...args) => void;
}

type IProps = IPropsScreenReportGrid & IDispatchProps;

const ReportGrid = ({ items, totalItems, pageIndex, columnsTable, isLoadingRegisters, reportFetchRegisterAsync, reportChangeFieldValue }: IProps) => {
  const SHOWING = useTranslation({ id: "showing" });
  const OF = useTranslation({ id: "of" });
  const REGISTERS = useTranslation({ id: "registers" });
  const fetchReport = useCallback(() => reportFetchRegisterAsync(), [reportFetchRegisterAsync]);

  const handleTableChange = (pagination) => {
    reportChangeFieldValue("itemsByPage", pagination.pageSize);
    reportChangeFieldValue("pageIndex", pagination.current);
    fetchReport();
  };

  return (
    <S.ReportTableContainer>
      <Table
        rowKey="id"
        style={{ whiteSpace: "pre-wrap" }}
        columns={[...columnsTable]}
        dataSource={items}
        pagination={{
          current: pageIndex,
          pageSizeOptions: ["10", "20", "50"],
          total: totalItems,
          showSizeChanger: true,
          defaultPageSize: 10,
          defaultCurrent: pageIndex,
          showTotal: (total, range) => `${SHOWING} ${range[0]}-${range[1]} ${OF} ${total} ${REGISTERS}`,
        }}
        onChange={handleTableChange}
        loading={isLoadingRegisters}
        scroll={{ x: 1500 }}
        summary={() => (
          <Table.Summary fixed>
            <Table.Summary.Cell index={0} colSpan={3}></Table.Summary.Cell>
          </Table.Summary>
        )}
        sticky={true}
      />
    </S.ReportTableContainer>
  );
};

const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...ReportActions }, dispatch);

const mapStateToProps = (state) => ({
  items: state.Report.items,
  totalItems: state.Report.totalItems,
  itemsByPage: state.Report.filter.itemsByPage,
  pageIndex: state.Report.filter.pageIndex,
  isLoadingRegisters: state.Report.isLoadingRegisters,
});

export default connect(mapStateToProps, mapDispatchToActions)(ReportGrid);
